var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.name === 'create-kokuban-detail')?_c('ConstructionFolder',{attrs:{"currentConstruction":_vm.currentConstruction}}):_vm._e(),_c('router-view',{attrs:{"currentConstruction":_vm.currentConstruction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }